import * as React from 'react';
import * as moment from 'moment';
import 'moment/locale/ja';
import styled from 'styled-components';
import { colors } from 'kaizen-ui-colors/lib';
import Round from '../../domain/entity/Round';

interface IProps {
  round: Round;
}

const Wrapper = styled.div`
  padding-right: 8px;
  padding-left: 8px;
`;

const Dates = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  margin-bottom: 8px;
  color: ${colors.ash__b4bed5};
`;

const TimelineContainer = styled.div`
  position: relative;
`;

const BaseLine = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${colors.ash__b4bed5};
  border-radius: 5px;
`;

const ActualLine = BaseLine.extend`
  position: absolute;
  top: 0;
`;

const Dot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  position: absolute;
  top: -2px;
`;

const TriangleContainer = styled.div`
  position: relative;
  height: 10px;
`;

const Triangle = styled.div`
  position: absolute;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-bottom-style: solid;
  border-bottom-width: 5px;
`;

const RemainLabelContainer = styled.div`
  position: relative;
  height: 20px;
`;

const RemainLabel = styled.div`
  position: absolute;
  top: 2px;
  font-size: 11px;
  white-space: nowrap;
`;

const Warning = styled.div`
  font-weight: 700;
  color: ${colors.lava__fe7877};
`;

const ElapsedDaysLabel = RemainLabel.extend``;

export const RoundTimeline = (props: IProps) => {
  const { round } = props;
  const now = moment();
  const startAt: moment.Moment = round.startedAt ? moment(round.startedAt) : moment(round.willStartAt);
  const endAt: moment.Moment = round.willEndAt ? moment(round.willEndAt) : moment(now).add(7, 'day');

  const isExpired = endAt < now;
  const diffDays = endAt.diff(startAt, 'days');
  const elapsedDays = now.diff(startAt, 'days');
  const remainDays = endAt.diff(now, 'days');
  const daysLeftPercentage = diffDays > 0 && diffDays <= 70 ? Math.floor(1000 / diffDays) / 10 : 100;
  const leftPosition = daysLeftPercentage * elapsedDays > 99.5 ? 99.5 : elapsedDays * daysLeftPercentage;
  const currentLeftPosition = leftPosition <= 0 ? 0 : leftPosition - 0.5;

  const baseColor = remainDays <= 1 ? colors.lava__fe7877 : colors.denim__5fa9ff;

  const LineDots: JSX.Element[] = [];
  LineDots.push(<Dot key={`${round.id}-StartDot`} style={{ left: '-2px', backgroundColor: baseColor }} />);
  LineDots.push(<Dot key={`${round.id}-EndDot`} style={{ right: '-2px', backgroundColor: baseColor }} />);
  const diffWeeks = endAt.diff(startAt, 'weeks') + (diffDays % 7 == 0 ? 0 : 1);
  if (!isExpired && diffWeeks >= 2 && diffWeeks <= 10) {
    Array.from({ length: diffWeeks - 1 }, (_, i) => {
      LineDots.push(
        <Dot
          style={{ left: `${daysLeftPercentage * 7 * (i + 1) - 5}%`, backgroundColor: baseColor }}
          key={`${round.id}-Dot${i}`}
        />,
      );
    });
  }

  return (
    <Wrapper>
      <Dates>
        <div>{moment(startAt).format('YYYY-MM-DD (dd)')}</div>
        <div>{round.willEndAt ? moment(endAt).format('YYYY-MM-DD (dd)') : '設定なし'}</div>
      </Dates>
      <TimelineContainer>
        <BaseLine />
        <ActualLine style={{ width: `${leftPosition}%`, backgroundColor: `${baseColor}` }} />
        {LineDots}
        {daysLeftPercentage != 0 && elapsedDays >= 0 && !isExpired ? (
          <React.Fragment>
            <TriangleContainer>
              <Triangle style={{ left: `calc(${currentLeftPosition}% - 2.5px)`, borderBottomColor: `${baseColor}` }} />
            </TriangleContainer>
            {round.willEndAt && remainDays >= 0 ? (
              <RemainLabelContainer>
                <RemainLabel style={{ left: `calc(${currentLeftPosition}% - 20px)`, color: `${baseColor}` }}>
                  あと{remainDays}日
                </RemainLabel>
              </RemainLabelContainer>
            ) : (
              <RemainLabelContainer>
                <ElapsedDaysLabel style={{ left: `calc(${currentLeftPosition}% - 20px)`, color: `${baseColor}` }}>
                  {elapsedDays}日経過
                </ElapsedDaysLabel>
              </RemainLabelContainer>
            )}
          </React.Fragment>
        ) : null}
        {isExpired ? <Warning>[異常] 既に終了予約日を過ぎてます！</Warning> : null}
      </TimelineContainer>
    </Wrapper>
  );
};



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/RoundTimeline.tsx